import React from 'react'
import ColorItem from '../colorItem'
import classNames from 'clsx'
import styles from './index.module.css'

export default class ColorPicker extends React.Component<any> {
  render() {
    const { items, value, onChange } = this.props
    return (
      <div className="flc">
        {items.map(item => (
          <div
            className={classNames('flc', styles.colorPicker)}
            key={item.color}
            onClick={() => onChange(item.id)}
          >
            <ColorItem
              className={styles.colorPickerColor}
              color={item.color}
              isActive={item.id === value}
            />
            <div className={styles.colorPickerLabel}>{item.name}</div>
          </div>
        ))}
      </div>
    )
  }
}
